import { Component, inject } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-ts-and-cs-bottom-sheet",
  standalone: true,
  imports: [MatIconModule],
  templateUrl: "./ts-and-cs-bottom-sheet.component.html",
  styleUrl: "./ts-and-cs-bottom-sheet.component.scss",
})
export class TsAndCsBottomSheetComponent {
  private _bottomSheetRef =
    inject<MatBottomSheetRef<TsAndCsBottomSheetComponent>>(MatBottomSheetRef);

  dismiss() {
    this._bottomSheetRef.dismiss();
  }
}
